<template lang="pug">
  .lightworks-swatch-selector(v-if="showSwatches")
    PdpSwatchButton(
      v-for="item in lightWorksRecommendations"
      @click="selectProduct(item)"
      :class="swatchWidthClass"
      :selected="item.url_key == product.url_key"
      :label="item.name"
      :img-url="swatchImgUrl(item)"
      :img-alt-text="item.name"
      :key="item.id"
      tabindex="0"
    )

</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import PdpSwatchButton from "../../../PdpSwatchButton/PdpSwatchButton";
  export default {
    name: "LightWorksSwatchSelector",
    components: { PdpSwatchButton },

    inject: ['getObjProperty'],

    computed: {
      ...mapState('customer', [
        'cdata'
      ]),
      ...mapState('pdp', ['product']),
      ...mapState('colorAdvisor', ['lightWorksRecommendations']),

      selectedProduct() {
        return this.product.url_key;
      },

      swatchWidthClass() {
        switch (this.lightWorksRecommendations.length) {
          case 3:
            return 'xs-4';

          case 2:
            return 'xs-6';

          default:
            return 'xs-12';
        }
      },

      showSwatches() {
        return this.lightWorksRecommendations.length > 1;
      }
    },

    methods: {
      ...mapActions('colorAdvisor', ['getLightWorksRecommendations']),

      selectProduct(item) {
        this.$router.push('/product/' + item.url_key);
      },

      isSelected(item) {
        return item.url_key == this.product.url_key;
      },

      swatchImgUrl(item) {
        return this.getObjProperty(item, 'images.squareSwatch');
      }
    },

    mounted() {
      if (this.getObjProperty(this, 'cdata.bestMatches.0')) {
        this.getLightWorksRecommendations();
      }
    }
  };
</script>

<style scoped lang="stylus">

</style>